import React, {useCallback, useContext} from 'react';

import {MessageContext} from 'src/contexts/message-context';

import Button from '@pb/kit-component-button';

import {usePostponeDraft} from '../hooks/usePostponeDraft';

type Props = {
    draftId: number,
    onPostpone: () => void,
};

export const PostponeSsoDraft = ({draftId, onPostpone}: Props) => {
    const {setErrorMessage, setSuccessMessage} = useContext(MessageContext);
    const onSuccess = useCallback(() => {
        setSuccessMessage('SSO draft postponement was successful');
        onPostpone();
    }, [onPostpone, setSuccessMessage]);
    const {event, busy} = usePostponeDraft({draftId, onSuccess, onFail: setErrorMessage});

    return (
        <Button variant="Type.PRIMARY" busy={busy} onClick={() => event()}>
            Client need more time to test
        </Button>
    );
};
